export default function TermsConditionsPage() {
  return (
    <div className="py-20 md:py-32">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl sm:text-5xl font-bold text-primary mb-8">Terms & Conditions</h1>
        <div className="prose prose-lg max-w-none space-y-6 text-muted-foreground">
          <p className="text-sm text-muted-foreground">Last Updated: January 2026</p>
          
          <section className="mt-8">
            <h2 className="text-2xl font-bold text-primary mb-4">1. Agreement to Terms</h2>
            <p className="leading-relaxed">
              These Terms and Conditions ("Terms") govern your use of the Get Logo Trademarked website and services. By accessing or using our services, you agree to be bound by these Terms. If you do not agree to these Terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">2. Services Provided</h2>
            <p className="leading-relaxed mb-4">
              Get Logo Trademarked provides intellectual property services including:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Federal trademark registration services with the United States Patent and Trademark Office (USPTO)</li>
              <li>Copyright registration services with the U.S. Copyright Office</li>
              <li>Comprehensive trademark search and availability analysis</li>
              <li>Company formation services (LLC and Corporation filing)</li>
              <li>Amazon Brand Registry enrollment assistance</li>
              <li>Intellectual property consulting and legal document preparation</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">3. Service Fees and Payment</h2>
            <p className="leading-relaxed mb-4">
              Our service fees are separate from government filing fees charged by USPTO, U.S. Copyright Office, or state agencies. All fees must be paid in full before we begin work on your application unless otherwise agreed in writing. Government filing fees are non-refundable once submitted to the relevant government agency.
            </p>
            <p className="leading-relaxed">
              We accept payment via credit card, debit card, and other payment methods as displayed on our website. All payments are processed securely through third-party payment processors.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">4. Client Responsibilities</h2>
            <p className="leading-relaxed mb-4">You agree to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Provide accurate, complete, and truthful information for all applications and filings</li>
              <li>Respond promptly to requests for additional information or documentation</li>
              <li>Review all documents and applications before submission for accuracy</li>
              <li>Maintain confidentiality of your account credentials</li>
              <li>Notify us immediately of any changes to your contact information</li>
              <li>Comply with all applicable trademark and intellectual property laws</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">5. Trademark Registration Disclaimers</h2>
            <p className="leading-relaxed mb-4">
              <strong>No Guarantee of Approval:</strong> We cannot guarantee that the USPTO or any government agency will approve your trademark or copyright application. Approval depends on many factors including trademark distinctiveness, potential conflicts with existing marks, and compliance with legal requirements.
            </p>
            <p className="leading-relaxed mb-4">
              <strong>Timeline:</strong> USPTO trademark registration typically takes 8-12 months but timelines vary. We cannot control or guarantee government processing times.
            </p>
            <p className="leading-relaxed">
              <strong>Search Limitations:</strong> Trademark searches identify known conflicts but cannot guarantee that no conflicts exist. Some common law trademarks and pending applications may not appear in database searches.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">6. Refund Policy</h2>
            <p className="leading-relaxed mb-4">
              Service fees are refundable only if we have not yet begun work on your application. Once work has commenced, our service fees are non-refundable. Government filing fees paid to USPTO or other government agencies are non-refundable under any circumstances.
            </p>
            <p className="leading-relaxed">
              If your trademark application is rejected due to our error or negligence in filing, we will refund our service fees (excluding government fees) or offer to re-file at no additional service charge.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">7. Intellectual Property Rights</h2>
            <p className="leading-relaxed">
              All content on our website, including text, graphics, logos, images, and software, is the property of Get Logo Trademarked or its licensors and is protected by copyright and trademark laws. You may not reproduce, distribute, or create derivative works without our express written permission.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">8. Limitation of Liability</h2>
            <p className="leading-relaxed">
              To the maximum extent permitted by law, Get Logo Trademarked shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from your use of our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">9. Attorney-Client Relationship</h2>
            <p className="leading-relaxed">
              Our services are provided by professional trademark agents and legal document preparers. Unless specifically stated otherwise, our services do not create an attorney-client relationship. We recommend consulting with a licensed attorney for complex legal matters or if you require legal advice beyond trademark filing services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">10. Confidentiality</h2>
            <p className="leading-relaxed">
              We maintain the confidentiality of your information in accordance with our Privacy Policy. However, trademark applications become public record once filed with the USPTO, and certain information will be publicly accessible through government databases.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">11. Governing Law and Jurisdiction</h2>
            <p className="leading-relaxed">
              These Terms shall be governed by and construed in accordance with the laws of the State of California, without regard to its conflict of law provisions. Any disputes arising from these Terms or our services shall be resolved in the courts located in Los Angeles County, California.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">12. Changes to Terms</h2>
            <p className="leading-relaxed">
              We reserve the right to modify these Terms at any time. We will notify you of material changes by posting the updated Terms on our website with a new "Last Updated" date. Your continued use of our services after such changes constitutes acceptance of the modified Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">13. Contact Information</h2>
            <p className="leading-relaxed mb-4">
              For questions about these Terms and Conditions, please contact us:
            </p>
            <div className="bg-background-surface p-6 rounded-sm">
              <p className="font-semibold text-primary">Get Logo Trademarked</p>
              <p>468 N Camden Dr</p>
              <p>Beverly Hills, CA 90210</p>
              <p>Email: Info@getlogotrademarked.com</p>
              <p>Phone: +1 (123) 123-4567</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">14. Severability</h2>
            <p className="leading-relaxed">
              If any provision of these Terms is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum extent necessary, and the remaining provisions will remain in full force and effect.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">15. Entire Agreement</h2>
            <p className="leading-relaxed">
              These Terms, together with our Privacy Policy, constitute the entire agreement between you and Get Logo Trademarked regarding our services and supersede any prior agreements or understandings.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
